import React, {
  Component,
  // eslint-disable-next-line no-unused-vars
  Dispatch,
} from "react";
import { connect } from "react-redux";
import {
  // eslint-disable-next-line no-unused-vars
  BasicTable, ConfirmationModal, ModalPopup, ProblemDetails, SystemFeatures,
} from "isuppli-react-components";

import { clearApiErrors, hideError } from "../../store/actions";

// eslint-disable-next-line no-unused-vars
import { ReduxState } from "../../store/ReduxState";

const mapStateToProps = (state: ReduxState) => ({
  showError: state.showError,
  apiErrors: state.apiErrors,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  hideError: () => {
    dispatch(hideError());
  },
  clearApiErrors: () => {
    dispatch(clearApiErrors());
  },
});

interface AppErrorBoundaryProps {
  hideError: () => void,
  clearApiErrors: () => void,
  showError: boolean,
  children: React.ReactNode,
  apiErrors: any,
}

interface AppErrorBoundaryState {
  hasError: boolean,
}

class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  constructor(props: AppErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // eslint-disable-next-line no-console
    console.error({ error, errorInfo });
  }

  closeErrorModal = () => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.hideError();
    this.setState({
      hasError: false,
    });
  }

  render() {
    const {
      children,
      showError,
      apiErrors,
      // eslint-disable-next-line no-shadow
      clearApiErrors,
    } = this.props;

    const {
      hasError,
    } = this.state;
    const errorModalHeader = apiErrors?.errors?.length > 1 ? "Something(s) went wrong" : "Something went wrong";
    const errorModal = (apiErrors?.errors?.length > 0
      ? (
        <div className="px-2 mx-2">
          <ModalPopup
            size="extra-large"
            heading={errorModalHeader}
            subheading="An error occurred. Please try again or contact your system administrator."
            image="error"
            hasCancel={false}
            onClose={() => { }}
            buttons={[{
              key: "ok",
              label: "OK",
              onClick: () => {
                this.closeErrorModal();
                clearApiErrors();
              },
              color: "primary",
            }]}
          >
            <BasicTable
              viewSubRowFeature={SystemFeatures.None}
              emptyMessage="No errors available"
              columns={[
                "Status Code",
                "Error",
                "Message",
                "SubSystem",
              ]}
              rows={apiErrors?.errors?.map((error: ProblemDetails) => [
                {
                  key: `${error.traceId}_code`,
                  valueTemplate: () => (
                    <span
                      className="font-weight-bold text-danger"
                    >
                      {error.status}
                    </span>
                  ),
                },
                {
                  key: `${error.traceId}_error`,
                  valueTemplate: () => (
                    <span
                      className="font-weight-bold text-danger"
                    >
                      {error.title}
                    </span>
                  ),
                },
                {
                  key: `${error.traceId}_message`,

                  valueTemplate: () => (
                    <span
                      className="font-weight-bold text-danger"
                    >
                      {error.additionalDetails?.message}
                    </span>
                  ),
                },
                {
                  key: `${error.traceId}_subSystem`,
                  value: error.additionalDetails?.subSystem,
                },
              ])}
              subRows={
                apiErrors?.errors?.map((error: ProblemDetails) => (
                  <div>
                    <p>
                      <b>Trace Id: </b>
                      {error.traceId}
                    </p>
                    <br />
                    <p>
                      <b>URL: </b>
                      {error.url}
                    </p>
                    <br />
                    <p>
                      <b>StackTrace:</b>
                      {error.additionalDetails?.stackStrace}
                    </p>
                  </div>
                ))
              }
            />
          </ModalPopup>
        </div>

      )
      : (
        <ConfirmationModal
          heading="Something went wrong"
          onProceedClick={() => this.closeErrorModal()}
          onToggleModal={() => { }}
          proceedButtonText="OK"
          hasCancel={false}
          description="An error occurred. Please try again or contact your system administrator."
        />
      )
    );

    return (
      <>
        {children}
        {hasError || showError ? (
          errorModal
        ) : null}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppErrorBoundary);
